import { useQuery } from '@apollo/client';

import type { SerpsListItem } from '@xing-com/crate-jobs-domain-serps-constants';
import { SeoLinkBoxesDocument } from '@xing-com/crate-jobs-domain-serps-graphql';

import { useSerpsMatch } from './use-serps-match';

type UseSeoLinkBoxes = {
  data?: {
    kind: string;
    entries: SerpsListItem[];
  }[];
  loading: boolean;
  error?: Error | undefined;
};

const useGetSerpType = (): string => {
  const serpMatch = useSerpsMatch();

  if (serpMatch?.category === 'role' && serpMatch?.subcategory === 'city') {
    return 'local-jobRole';
  }

  if (serpMatch?.category === 'role') {
    return 'jobRole';
  }

  if (serpMatch?.category === 'skill') {
    return 'local-skill';
  }

  return '';
};

export const useSeoLinkBoxes = (): UseSeoLinkBoxes => {
  const serpType = useGetSerpType();
  const serpMatch = useSerpsMatch();

  const { data, loading, error } = useQuery(SeoLinkBoxesDocument, {
    variables: {
      location: serpMatch?.subcategoryValue,
      ...(serpType === 'local-skill' && { skill: serpMatch?.categoryValue }),
      ...((serpType === 'local-jobRole' || serpType === 'jobRole') && {
        jobRole: serpMatch?.categoryValue,
      }),
      serpType: serpType,
    },
    errorPolicy: 'all',
    skip: !serpType,
  });

  const serialized = data?.seoLinkBoxes?.collection.map((item) => {
    if (item === null || item.entries === null) {
      return null;
    }

    return {
      kind: item.kind,
      entries: item.entries.map((entry) => ({
        id: entry?.name || '',
        link: { url: entry?.url || '', label: entry?.name || '' },
        count: entry?.jobCount || 0,
      })),
    };
  });

  return { data: serialized?.filter((item) => item !== null), loading, error };
};
